import { render, staticRenderFns } from "./BeginningInitialChallengeScreen.vue?vue&type=template&id=c682fc20&scoped=true"
import script from "./BeginningInitialChallengeScreen.vue?vue&type=script&lang=js"
export * from "./BeginningInitialChallengeScreen.vue?vue&type=script&lang=js"
import style0 from "./BeginningInitialChallengeScreen.vue?vue&type=style&index=0&id=c682fc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c682fc20",
  null
  
)

export default component.exports